import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-search",
  "use": "ico-search-usage",
  "viewBox": "0 0 17.652 18.652",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17.652 18.652\" id=\"ico-search\">\n  <path id=\"ico-search_Union_9\" data-name=\"Union 9\" d=\"M999.391,110.391a6.25,6.25,0,1,1,2.359-4.891,6.225,6.225,0,0,1-2.359,4.891l5.377,5.377Z\" transform=\"translate(-988 -98)\" fill=\"none\" stroke=\"#737878\" stroke-width=\"2.5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol